// FilterByMenu.tsx
import { Box, ListItemText, Menu, MenuItem, Typography } from "@mui/material";
import { FilterPngIcon } from "@platformx/shared/static-assets";
import { t } from "i18next";
import { useState } from "react";
import useDamContent from "./DamContent.style";

export const FILTER_BY_OPTIONS = [
  { text: "All", val: "ALL" },
  { text: "Playable", val: "PLAYABLE" },
];

export const FilterByMenu = ({ filterBy, setFilterBy }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const classes = useDamContent();

  const handleClose = () => {
    setAnchorEl(null);
  };
  const value = FILTER_BY_OPTIONS.find((obj) => obj.val === filterBy) || FILTER_BY_OPTIONS[0];

  return (
    <Box className={classes.filtermenu}>
      <Box
        onClick={(e) => setAnchorEl(e.currentTarget)}
        className={classes.filterbox}
        id='filter-by-button'>
        <img src={FilterPngIcon} alt='filter' style={{ width: 16, height: 16 }} />
        <Typography variant='p3regular' className={classes.typoTextn}>
          {t("filter") || "Filter"}: {value?.text}
        </Typography>
      </Box>
      <Menu
        id='filter-by-menu'
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        MenuListProps={{
          style: {
            width: anchorEl ? anchorEl.clientWidth : undefined,
            minWidth: "140px",
          },
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}>
        <Box className={classes.menuitembox}>
          {FILTER_BY_OPTIONS.map((item) => (
            <MenuItem
              key={item.val}
              className={classes.menuItemhover}
              onClick={() => {
                setFilterBy(item.val);
                handleClose();
              }}
              data-testid='filter-by-menu'>
              <ListItemText primary={<Typography variant='p2regular'>{item.text}</Typography>} />
            </MenuItem>
          ))}
        </Box>
      </Menu>
    </Box>
  );
};
